const DEV = process.env.NODE_ENV === 'development';

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('init common');

    // Remove no-js
    document.documentElement.className = "js";

    // Test touch
    if (!("ontouchstart" in document.documentElement)) {
      document.documentElement.classList.add("no-touch");
    } else {
      document.documentElement.classList.add("touch");
    }

    const scrollTopBtn = document.getElementById('scroll_top')
    scrollTopBtn.addEventListener('click', () => {
      scrollTop()
    })

    let didScroll = false;

    const cover_box = document.querySelector(".cover_box")
    const cover_image = document.querySelector(".cover_page")
   
    window.onscroll = () => {
      didScroll = true;
      
      // parallax
      if(cover_image){
        const distance = window.scrollY;
        cover_image.style.transform = `scale(1.4) translateY(${distance * .3}px)`;
      }
    }

    const offset = 400;
    setInterval(() => {
      if ( didScroll ) {
          didScroll = false;
          if(window.pageYOffset > offset || document.documentElement.scrollTop > offset){
            scrollTopBtn.classList = 'show'
          } else {
            scrollTopBtn.classList = ''
          }
      }
    }, 250);

    function scrollTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    const menu_btn = document.querySelectorAll('.menu_btn')[0]
    const menu_full = document.querySelectorAll('.menu-full')[0]
    const menu_item = document.querySelectorAll('.menu-item')

    menu_item.forEach((item, i) => {
      item.addEventListener('click', function(e) {
        menu_full.classList.remove('show_menu');
        document.body.classList.remove('noScroll');
        menu_btn.classList.remove('active');
      });
    });


    menu_btn.addEventListener('click', function(e) {
      this.classList.toggle('active');
      menu_full.classList.toggle('show_menu');
      document.body.classList.toggle('noScroll');
    });

    document.addEventListener('keyup', function(e) {
      if ( e.keyCode === 27 && menu_full.classList.contains('show_menu')){
        menu_full.classList.remove('show_menu');
        document.body.classList.remove('noScroll');
        menu_btn.classList.remove('active');
      }
    });


    const loader = document.getElementById('loader')

    function hideLoader(){
      loader.classList.add('hide');
    }

    function showLoader(){
      loader.classList.add('show');
    }

    setTimeout(function(){hideLoader()}, 2000);

    window.addEventListener('load', function(){
      hideLoader();
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.log('finalize common');
  },
};
